module.exports = __webpack_public_path__ + "img/Escudo.89048f43.png";